import { LISTAR_CATTIPORECETAS } from "../../types";

export default (state, action) => {
  switch (action.type) {
    case LISTAR_CATTIPORECETAS:
      return {
        ...state,
        tiposRecetas: action.payload,
      };
    default:
      return state;
  }
};
